import { render, staticRenderFns } from "./TableCellText.vue?vue&type=template&id=64a4c2da&"
import script from "./TableCellText.vue?vue&type=script&lang=js&"
export * from "./TableCellText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports